import { Box, Text } from '@wix/design-system';
import React, { FC, useCallback } from 'react';

import { IInvoiceItem } from '../../../common/messageCreators';
import { SelectorItem } from '../Selectors';
import { Time } from '../Time';

interface Props {
  onClick: (item: IInvoiceItem, index: number) => void;
  item: IInvoiceItem;
  position: number;
  hasFocus: boolean;
}

export const InvoiceItem: FC<Props> = ({ onClick, item, position, hasFocus }) => {
  const clickHandler = useCallback(() => onClick(item, position), [item, position, onClick]);

  return (
    <SelectorItem key={item._id} link={item.link} onClick={clickHandler} hasFocus={hasFocus}>
      <Box flexWrap="wrap">
        <Box width="50%">
          <Text ellipsis>{item.serviceType}</Text>
        </Box>
        <Box width="50%" align="right">
          <Text ellipsis>{item.amount}</Text>
        </Box>

        <Box width="100%" marginBottom="SP1">
          <Text ellipsis>{item.productName}</Text>
        </Box>

        <Box width="50%">
          <Text secondary light size="small">
            <Time date={item.date}>{item.date}</Time>
          </Text>
        </Box>
        <Box width="50%" align="right">
          <Text secondary light size="small" ellipsis>
            {item.status}
          </Text>
        </Box>

        <Box width="50%">
          <Text secondary light size="small" ellipsis>
            {item.invoiceDocId}
          </Text>
        </Box>
        <Box width="50%" align="right">
          <Text secondary light size="small" ellipsis>
            {item.paymentLabel}
          </Text>
        </Box>
      </Box>
    </SelectorItem>
  );
};
